
import React                                       from 'react';
import { Observe }                                 from 'rewire-core';
import {
  WithStyle,
  IActionMenuItem,
}                                                  from 'rewire-ui';
import { Theme }                                   from '@material-ui/core/styles';
import AddIcon                                     from '@material-ui/icons/AddCircleOutline';
import OptionsActionMenu                           from '../ui/OptionsActionMenu';
import DateRangeNav                                from '../ui/DateRangeNav';
import { withStyles }                              from '../utility/styles';
import SchedulingCandidateEmployeeGridModel        from './SchedulingCandidateEmployeeGridModel';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    marginBottom: '2px',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    '& > :first-child': {
      flex: '1',
      marginRight: '15px',
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginBottom: '7px',
  },
  button: {
    minWidth: '0px',
    minHeight: '0px',
    padding: '0px',
    marginLeft: '15px',
    '&:first-child': {
      marginLeft: '0px',
    },
  },
});

interface ISchedulingCandidateEmployeeGridHeaderProps {
  model: SchedulingCandidateEmployeeGridModel;
}

type SchedulingCandidateEmployeeGridHeaderProps = WithStyle<ReturnType<typeof styles>, ISchedulingCandidateEmployeeGridHeaderProps>;

class SchedulingCandidateEmployeeGridHeader extends React.PureComponent<SchedulingCandidateEmployeeGridHeaderProps> {
  schedulingGridOptionsItems: IActionMenuItem[];

  constructor(props: SchedulingCandidateEmployeeGridHeaderProps) {
    super(props);

    this.schedulingGridOptionsItems = [
      {name: 'addSchedulingRule', title: 'Add Scheduling Rule', icon: AddIcon, onClick: this.showAddScheduleRuleDialog, disabled: () => !this.props.model.showAddScheduleRuleDialogFn || !!this.props.model.viewOnly},
    ];
  }

  showAddScheduleRuleDialog = () => {
    this.props.model.showAddScheduleRuleDialogFn?.();
  };

  render() {
    const {model, classes} = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <DateRangeNav model={model.dateRangeNavModel} />
        <div className={classes.buttonsContainer}>
          <div className={classes.buttons}>
            <Observe render={() => (
              < >
              {model.showAddScheduleRuleDialogFn
                ? <OptionsActionMenu title='More Options' tooltip='More Options' classes={{menuButton: classes.button}} items={this.schedulingGridOptionsItems} />
                : null
              }
              </>
            )} />
          </div>
        </div>
      </div>
    )} />;
  }
}

export default withStyles<ISchedulingCandidateEmployeeGridHeaderProps>(styles, SchedulingCandidateEmployeeGridHeader);
